import { Avatar, Button, IconButton, TableCell, TableRow } from '@mui/material';
import {  UserDto, UserRemoteAccessSettingsDto } from '@sr/dto';
import { useDeleteRemoteAccess, useRemoteAccessList, useUpdateRemoteAccess } from './remote-access.hook';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { FormDialog } from 'shared/ui/form-dialog';
import { RemoteAccessFormFields } from './remote-access.form-fields';
import { formTools, FormValues, notificationsConfig } from './remote-access.form-tools';
import AddIcon from '@mui/icons-material/Add';

import { useCreateOrEditDialog } from 'hooks/create-or-edit-dialog.hook';
import { GridLayout } from 'shared/ui/grid-layout';
import { LinkToUser } from 'shared/ui/links/link-to-user';
import useConfirmDialog from 'hooks/confirm-dialog.hook';
import { usePagingParams } from 'shared/hooks/paging-params';
import { useSnack } from 'shared/ui/snack';
import { extractNestJsErrorMessage } from 'shared/api/rtk-query';
import { ErrorBanner } from 'shared/ui/error-banner';

const columns = ['', 'Менеджер', 'Удаленный доступ', 'Разрешенный Ip', 'Действия'];

type RowProps = {
  item: UserRemoteAccessSettingsDto
  deleteFn: () => void
  updateFn: () => void
}

const RemoteAccessRow = ({ item, deleteFn, updateFn }:  RowProps ) => {

  return (<>
    <TableRow key={item.id}>
      <TableCell>
        <Avatar />
      </TableCell>
      <TableCell>
        <LinkToUser user={item.user as UserDto} />
      </TableCell>
      <TableCell>
        {item.remoteAccess ? 'Включен' : 'Отключен'}
      </TableCell>
      <TableCell>
        {item.remoteAccessIP}
      </TableCell>
      <TableCell>
        <IconButton onClick={updateFn}>
          <EditIcon />
        </IconButton>
        <IconButton onClick={deleteFn}>
          <DeleteIcon />
        </IconButton>
      </TableCell>
    </TableRow>
  </>);
};


export const RemoteAccessList = () => {
  const [paging, setPaging] = usePagingParams();
  const { showSuccess, showError } = useSnack();
  const { items, isLoading, error, totalItemsCount } = useRemoteAccessList(paging);
  const deleteRemoteAccess = useDeleteRemoteAccess();
  const updateRemoteAccess = useUpdateRemoteAccess();
  const confirmDialog = useConfirmDialog();

  const { dialogProps, itemToEdit, openToAdd, openToEdit } = useCreateOrEditDialog<UserRemoteAccessSettingsDto, UserRemoteAccessSettingsDto, UserRemoteAccessSettingsDto, FormValues>({
    addHandler: async (dto) => {
      await updateRemoteAccess(dto);
    },
    updateHandler: async (dto) => {
      await updateRemoteAccess(dto);
    },
    formTools,
    notificationsConfig
  });

  const handleDelete = (id: number) => {
    confirmDialog({ content: 'Отчистить настройки удаленного доступа для этого пользователя?', title: 'Требуется подтверждение' })
      .then(() => deleteRemoteAccess(id)
        .then(() => showSuccess('Настройки удаленного доступа очищены'))
        .catch((e) => showError('Ошибка очистки настройки удаленного доступа', extractNestJsErrorMessage(e))));

  };

  if (error) {
    return <ErrorBanner errorMessage={error} />;
  }

  return (
    <>
      <Button onClick={openToAdd} variant='contained' startIcon={<AddIcon />} sx={{ mb: 2 }}>Добавить</Button>
      <GridLayout
        columns={columns}
        isLoading={isLoading}
        items={items}
        pagingData={paging}
        onChangePaging={setPaging}
        totalItemsCount={totalItemsCount}
        itemRender={(item) => <RemoteAccessRow item={item} deleteFn={() => handleDelete(item.id)} updateFn={() => openToEdit(item)} />}
        noItemsText='Список пуст' />
      <FormDialog<FormValues>
        {...dialogProps}
        renderTitle={!itemToEdit ? 'Добавить настроки удаленного доступа' : 'Настройки удаленного доступа'}
        renderForm={(props) => <RemoteAccessFormFields {...props} withManager={!itemToEdit} />}
      />
    </>
  );
};
